export const checkoutInfoModal = vm => Object.freeze({
  maxLimit: {
    icon: '/assets/images/cart_replace.svg',
    title: vm.$t('checkout.maxLimit.maxLimitTitle'),
    description: vm.$t('checkout.maxLimit.maxLimitDesc'),
    cta: vm.$t('checkout.maxLimit.chooseContract'),
    redirect: false,
    closeVisible: false
  },
  businessNumber: {
    icon: '/assets/images/cart_replace.svg',
    title: vm.$t('checkout.businessModal.businessTitle'),
    description: vm.$t('checkout.businessModal.businessDesc'),
    redirect: true,
    closeVisible: true
  }
})
